import { useEffect, useRef, useState } from "react";
import { requestThumb, thumbCache } from "@/lib/thumbs";

// Image whose request goes through the thumbnail scheduler; priority follows on-screen visibility.
export const ThumbImg = ({ src, className, alt = "", fallback = null }) => {
  const ref = useRef(null);
  const [obj, setObj] = useState(() => thumbCache(src) || null);
  const [failed, setFailed] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const io = new IntersectionObserver((e) => setVisible(e[0].isIntersecting), { rootMargin: "100px" });
    io.observe(el);
    return () => io.disconnect();
  }, []);

  useEffect(() => {
    if (!src || failed || (obj && thumbCache(src) === obj)) return undefined;
    return requestThumb(src, visible ? 2 : 1, (o) => (o ? setObj(o) : setFailed(true)));
  }, [src, visible, obj, failed]);

  if (failed && fallback) return fallback;
  return obj ? <img ref={ref} src={obj} alt={alt} className={className} draggable={false} /> : <span ref={ref} className="thumb-wait" />;
};
